import { ITablaState, TablaActions, TablaTypes } from "../../consts/TablaTypes";

const initialState : ITablaState = { archivosAdjuntos: [] };

export default function (state = initialState, action : TablaActions) {
  switch (action.type) {
    case TablaTypes.AGREGAR_ARCHIVOS:
      const nuevosArchivos = [
        ...new Set([...state.archivosAdjuntos, ...action.payload]),
      ];
      return { ...state, archivosAdjuntos: nuevosArchivos };
    case TablaTypes.ELIMINAR_ARCHIVO:
      return {
        ...state,
        archivosAdjuntos: [
          ...state.archivosAdjuntos.filter(
            (archivo) => archivo !== action.payload
          ),
        ],
      };
    case TablaTypes.LIMPIAR_ADJUNTOS:
      return {
        ...state,
        archivosAdjuntos: [],
      };
    default:
      return { ...state };
  }
}
